// @flow

import React from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table';
import { zoomTableConfig, zoomTableActionsConfig } from './zoomTableConfig';
// import styles from "./zoomTable.scss";

// Quietly using react-table inside

type Props = {
  configKey: string, // table config key is to be in sync with state.tabConfig.currentSelectedTab
  tableData: Array<Object>,
  actionFunctions?: Object,
  tableDataLength: number,
  paginationProps?: Object,
  loading?: boolean
};

class ZoomTable extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.tableData = this.props.tableData;
    // Below step will append action button on-click handlers now
    zoomTableActionsConfig[
      this.props.configKey
    ].actions = this.props.actionFunctions;
    this.setReactTableProps(this.props);
  }

  componentWillReceiveProps(nextProps) {
    // Update tableData
    this.tableData = nextProps.tableData;
    this.tableDataLength = nextProps.tableData.length;
    this.setReactTableProps(nextProps);
  }

  setReactTableProps(props) {
    Object.assign(ReactTableDefaults, {
      // defaultPageSize: Math.min(
      //   this.tableData.length,
      //   zoomTableConfig[props. configKey].minRows
      // ),
      //  defaultPageSize: zoomTableConfig[props.configKey].minRows,
      // minRows: Math.min(
      //   this.tableData.length,
      //   zoomTableConfig[props.configKey].minRows
      // ),
      // minRows: zoomTableConfig[props.configKey].minRows,

      showPageSizeOptions: false,
      manual:
        props.paginationProps && props.paginationProps.serverSidePagination,
      // pageSizeOptions: zoomTableConfig[props.configKey].pageSizeOptions,
      onFetchData: (tableState, instance) =>
        this.handleOnFetchData(tableState, instance),
      page: props.paginationProps && props.paginationProps.pageNumber,
      showPagination:
        (props.paginationProps && props.paginationProps.showPagination) ||
        false, // this.tableData && this.tableData.length > 0,
      defaultPageSize:
        (props.paginationProps && props.paginationProps.tableDataLength) ||
        props.tableDataLength,
      pageSize:
        (props.paginationProps && props.paginationProps.pageSize) ||
        this.tableDataLength,
      noDataText: zoomTableConfig[props.configKey].noDataText,

      style: zoomTableConfig[props.configKey].style,
      pages: props.paginationProps && props.paginationProps.pages
    });
  }

  handleOnFetchData(tableState, instance) {
    if (this.props.paginationProps && this.props.paginationProps.onFetchData) {
      this.props.paginationProps.onFetchData(tableState, instance);
    }
  }

  getColumns() {
    const { columns } = zoomTableConfig[this.props.configKey];

    if (this.props.removeActions) {
      if (columns.length > 1) {
        columns.splice(-1);
      }
    }

    return columns;
  }

  render() {
    return (
      <div
        className={`${
          zoomTableConfig[this.props.configKey].className
        } zoom-table-wrapper`}
      >
        <ReactTable
          key={`${this.props.configKey}-${this.props.paginationProps &&
            this.props.paginationProps.pages}`}
          getTrProps={this.props.getTrProps}
          loading={this.props.loading || false}
          data={this.tableData}
          columns={this.getColumns()}
          minRows={
            this.props.minRows !== undefined ? this.props.minRows : undefined
          }
          noDataText={
            this.props.noDataText ||
            zoomTableConfig[this.props.configKey].noDataText
          }
          showPageSizeOptions={false}
          manual={
            this.props.paginationProps &&
            this.props.paginationProps.serverSidePagination
          }
          onFetchData={(tableState, instance) =>
            this.handleOnFetchData(tableState, instance)
          }
          page={
            this.props.paginationProps && this.props.paginationProps.pageNumber
          }
          showPagination={
            (this.props.paginationProps &&
              this.props.paginationProps.showPagination) ||
            false
          }
          defaultPageSize={
            (this.props.paginationProps &&
              this.props.paginationProps.tableDataLength) ||
            this.tableDataLength
          }
          pageSize={
            (this.props.paginationProps &&
              this.props.paginationProps.pageSize) ||
            this.tableDataLength
          }
          style={zoomTableConfig[this.props.configKey].style}
          pages={this.props.paginationProps && this.props.paginationProps.pages}
        />
      </div>
    );
  }
}

ZoomTable.defaultProps = {
  actionFunctions: {}
};

export default ZoomTable;
